<template>
  <div class="container">
    <form @submit.prevent="onSubmit">

      <div class="row pt-3">

        <m-location-manager1 v-model:province="form.province_id" v-model:city="form.city_id"/>

      </div>

      <div class="row">
        <div class="form-group col-lg-3" v-if="addressName">
          <label v-t="'address.name'"></label>

          <input v-model="form.name" type="text" class="form-control" :disabled="form.sendForMe">

          <form-errors-manager :validation="v$.form.name"/>
        </div>

        <div class="form-group col-lg-9 text-right  ">
          <label for="inputAddress" v-t="'address.address'"></label>
          <input v-model="form.address" type="text" class="form-control address-text" id="inputAddress">
          <form-errors-manager :validation="v$.form.address"/>
        </div>
      </div>


      <div class="row pt-3">

        <div class="form-group col-lg-12 text-right  ">
          <label for="inputAddress" v-t="'address.description'"></label>
          <input v-model="form.description" type="text" class="form-control address-text" id="inputDescription">
          <form-errors-manager :validation="v$.form.description"/>
        </div>

        <div class="col-lg-4">
          <div class="form-group">
            <label v-t="'address.postal_code'"></label>
            <input v-model="form.postal_code"
                   ref="postal-code"
                   type="text" class="form-control text-left">
            <form-errors-manager :validation="v$.form.postal_code"/>
          </div>
        </div>

      </div>


      <button type="submit" class="btn btn-primary rounded-pill mt-2 w-100" v-t="'address.submit_button'">

      </button>

    </form>

  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import {useVuelidate} from '@vuelidate/core'
import {required, maxLength, minLength} from '@vuelidate/validators'
import FormErrorsManager from '../../validator/FormErrorsManager.vue'
import {findObjects} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import mLocationManager1 from "../../Location/LocationManager/LocationManager1";


export default {
  name: "AddressForm",
  components: {mLocationManager1, FormErrorsManager},
  props: {
    submitFunction: {},
    addressName: {default: false}
  },
  setup: () => ({v$: useVuelidate()}),
  data() {
    return {
      form: {
        id: '',
        name: '',
        description: '',
        address: '',
        province_id: '',
        city_id: '',
        postal_code: '',
        plate: '',
        default_address: 0,
      },
    }
  },
  validations() {
    return {
      form: {
        name: {requiredIf: this.addressName},
        description: {},
        address: {required},
        postal_code: {minLength: minLength(10), maxLength: maxLength(10)},
      }
    }
  },
  computed: {
    ...mapGetters({
      "provinces": "Province/getProvinces",
      "cities": "City/getCities"
    }),
    isProvinceFill() {
      return findObjects(this.$store.getters['Province/getProvinces'], this.form.province) != null
    },
  },
  methods: {
    ...mapActions({
      'provinceSearch': "Province/search"
    }),
    async onSubmit() {
      const result = await this.v$.form.$validate()
      if (!result) return
      let form = this.form
      if (!this.addressName) {
        form.name = form.address.slice(0, 30)
      }
      this.submitFunction(form);
    },
  },
  async mounted() {

    if (this.findAttributeOnSiteInfo('default_province').length > 0) {
      const province = this.findAttributeOnSiteInfo('default_province')[0];
      this.form.province = province.name
      await this.provinceSearch(province.name)
    }

    if (this.findAttributeOnSiteInfo('default_city').length > 0) {
      const site_info_city = this.findAttributeOnSiteInfo('default_city')[0];
      this.form.province = site_info_city.province.id
      this.form.city = site_info_city.id
    }

    if (this.findAttributeOnSiteInfo('require_postal_code_in_address')[0] == 1) {
      this.$refs["postal-code"].required = true
    }


  }
};

</script>

<style scoped>
.address-text {
  height: 5rem;
}

.color-btn {
  background-color: #bf61ee;
  border: none;
  color: white;
}
</style>